import { ValidationErrors, AbstractControl, ValidatorFn } from '@angular/forms';
import { PlOption } from '../pl-utils/models';

export function plValidOptionValidator(options: PlOption[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value } = control;
    if (value && !options.find((o) => o.value === value)) {
      return { invalidOption: true };
    }
    return null;
  };
}
